import {
    CREATE_DRAFT_COLLECTION,
    DELETE_DRAFT_COLLECTION,
    GET_DRAFT_COLLECTIONS,
    GET_DRAFT_COLLECTIONS_PAGE,
    DRAFT_COLLECTION_REQUEST,
    DRAFT_COLLECTION_REQUEST_SUCCESS,
    DRAFT_COLLECTION_REQUEST_FAILURE,
    UPDATE_DRAFT_COLLECTION
  } from "../types";
  
  const initialState = {
    draftCollections: [],
    draftCollectionsPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const draftCollectionReducer = (state = initialState, action) => {
    switch (action.type) {
      case DRAFT_COLLECTION_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_DRAFT_COLLECTIONS: {
        return {
          ...state,
          draftCollections: [...action.payload],
          loading: false,
          error: null
        }
      }
      case DRAFT_COLLECTION_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case GET_DRAFT_COLLECTIONS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          draftCollectionsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_DRAFT_COLLECTION:
        return {
          ...state,
          draftCollections: [action.payload, ...state.draftCollections],
          loading: false,
          error: null
        };
      case UPDATE_DRAFT_COLLECTION:
        const draftCollectionsData = state.draftCollections.slice(0);
        const uIndex = draftCollectionsData.findIndex((data) => data.id === action.payload.id);
        draftCollectionsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          draftCollections: [ ...draftCollectionsData ],
          loading: false,
          error: null
        };
      case DELETE_DRAFT_COLLECTION:
        const draftCollections = state.draftCollections?.slice(0);
        const index = draftCollections.findIndex((data) => data.id === action.id);
        if (index > -1) {
          draftCollections.splice(index, 1);
        }
        return {
          ...state,
          draftCollections: [...draftCollections],
          loading: false,
          error: null
        }
      case DRAFT_COLLECTION_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default draftCollectionReducer;
  